import React from "react";
import { getUrl } from "../../helpers/Pipes";
import { Icon } from "../Icon/Icon";

export const Logo = () => {
    return (
        <h1 className="logo">
            <a target="_blank" href={getUrl("home")}>
                {/* <Icon setViewBox="yes" name="logo" /> */}
                <img src={"https://www.compass.it/application/themes/compass/assets/img/loghi/logo-compass-banca.png.webp"} alt="" />
                <span className="logo-text">Compass</span>
            </a>
        </h1>
    );
};
